<template>
  <div class="bg-white rounded-lg border border-growth-50 overflow-hidden">
    <div class="flex justify-between items-center p-3 border-b border-growth-50">
      <h4 class="text-sm font-semibold text-growth-600 uppercase tracking-wide">Matching Practices</h4>
      <span class="text-xs text-growth-700">{{ formatNumber(total) }} total</span>
    </div>
    <div v-if="loading && practices.length === 0" class="text-growth-700 text-sm p-4 flex items-center gap-2">
      <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Loading...
    </div>
    <div v-else class="divide-y divide-growth-50 max-h-[400px] overflow-y-auto">
      <PracticeListItem
        v-for="p in practices"
        :key="p.TIN_ID || p.PAC_ID"
        :practice="p"
        :show-tags="true"
        @click="$emit('navigate', p)"
      />
      <div v-if="practices.length === 0" class="p-4 text-center text-growth-600 text-sm">
        No practices found
      </div>
    </div>
    <button
      v-if="practices.length < total"
      @click="$emit('load-more')"
      :disabled="loading"
      class="w-full py-2 text-sm text-growth-tangerine hover:text-growth-tangerine-hover disabled:opacity-50 transition-colors border-t border-growth-50"
    >
      {{ loading ? 'Loading...' : 'Load more' }}
    </button>
  </div>
</template>

<script>
import PracticeListItem from '../PracticeListItem.vue'

export default {
  name: 'PracticeListSection',
  components: {
    PracticeListItem,
  },
  props: {
    practices: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['load-more', 'navigate'],
  methods: {
    formatNumber(num) {
      if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M'
      if (num >= 1000) return (num / 1000).toFixed(1) + 'K'
      return num?.toLocaleString() || '0'
    },
  },
}
</script>
